import React, { useState, useEffect } from "react";
import { get } from "lodash";
import { fetchElectionComment } from "../../../api";
import styles from "./style.m.css";
import Icon from "../../atoms/icon";
import { Link } from "@quintype/components";
import { connect } from "react-redux";

const sign = require("jwt-encode");

const truncateContent = (content, maxLength) => {
  if (content.length <= maxLength) return content;
  return content.slice(0, maxLength) + "...";
};

const TnElectionCommentsWidget = props => {
  const [comments, setComments] = useState([]);
  const [offset, setOffset] = useState(0);
  const [totalComments, setTotalComments] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const COMMENTS_PER_PAGE = 30;
  const jwtKey = get(props, ["jwtKey"], "");

  function generateJWT(payload) {
    const secret = jwtKey;
    const jwt = sign(payload, secret);
    return jwt;
  }

  const fetchComments = (pageOffset = 0) => {
    setIsLoading(true);
    const PartyData = {
      _tn: Date.now()
    };

    fetchElectionComment(generateJWT(PartyData), "all", pageOffset, COMMENTS_PER_PAGE)
      .then(res => {
        const newComments = get(res, ["data", "items", "data"], []);
        const total = get(res, ["data", "items", "total"], 0);

        if (pageOffset === 0) {
          // Initial load
          setComments(newComments);
        } else {
          // Append to existing comments
          setComments(prevComments => [...prevComments, ...newComments]);
        }

        setTotalComments(total);
        setOffset(pageOffset + COMMENTS_PER_PAGE);
      })
      .catch(console.error)
      .finally(() => setIsLoading(false));
  };

  useEffect(() => {
    fetchComments(0);
  }, []);

  const loadMore = () => {
    if (!isLoading) {
      fetchComments(offset);
    }
  };

  const toggleCommentExpansion = commentIndex => {
    setComments(prevComments =>
      prevComments.map(
        (comment, index) => (index === commentIndex ? { ...comment, expanded: !comment.expanded } : comment)
      )
    );
  };

  const buildConstituencyHref = comment => {
    const slug = get(comment, ["thokuthi_slug"], "").toLowerCase();
    let href = `/election/tn-assembly-election-2026/constituency/${slug}`;

    if (typeof global !== "undefined" && global.location) {
      const regExp = /source=app/;
      if (regExp.test(global.location.href)) {
        href += href.includes("?") ? "&source=app" : "?source=app";
      }
    }

    return href;
  };

  return (
    <div className={`${styles["election-container"]} container`}>
      {comments &&
        comments.length > 0 && (
          <div className={styles["comments-wrapper"]}>
            <div className={styles["comments-wrapper-section"]}>
              <h1 className={styles["comments-headline"]}>
                <span>வாசகர்களின் கருத்துகள்</span>
              </h1>
              <div className={styles["comments-height"]}>
                {comments.map((comment, index) => (
                  <ul key={comment.id || index} className={styles["comments-section"]}>
                    <li className={styles["comments-header"]}>
                      <Icon type="icon-user" />
                      <div>
                        <h2>{get(comment, ["user_name"], "")}</h2>
                        <h3>
                          <Link href={buildConstituencyHref(comment)}>{get(comment, ["area"], "")}</Link>
                        </h3>
                      </div>
                    </li>
                    <li className={styles["comments-pblm"]}>
                      {comment && comment.expanded ? (
                        <div>
                          {get(comment, ["thokuthi_pblm"], "")}
                          <button onClick={() => toggleCommentExpansion(index)} className={styles["read-more-less"]}>
                            Read Less
                          </button>
                        </div>
                      ) : (
                        <div>
                          {truncateContent(get(comment, ["thokuthi_pblm"], ""), 200)}
                          {get(comment, ["thokuthi_pblm"], "").length > 200 && (
                            <button onClick={() => toggleCommentExpansion(index)} className={styles["read-more-less"]}>
                              Read More
                            </button>
                          )}
                        </div>
                      )}
                    </li>
                  </ul>
                ))}
              </div>
              {comments.length < totalComments && (
                <div className={styles["load-more-wrapper"]}>
                  <button
                    onClick={loadMore}
                    className={styles["load-more"]}
                    disabled={isLoading}
                    style={{ opacity: isLoading ? 0.6 : 1, cursor: isLoading ? "wait" : "pointer" }}
                  >
                    {isLoading ? <div>Loading...</div> : "Load More"}
                  </button>
                </div>
              )}
            </div>
          </div>
        )}
    </div>
  );
};

function mapStateToProps(state) {
  return { jwtKey: get(state, ["qt", "config", "JwtKey"]) };
}

export default connect(mapStateToProps)(TnElectionCommentsWidget);
